import React from 'react';
import DragDropComponente from '../../../componentes/dragdrog/dragdrop.componente';
import { Container, Row, Col } from 'reactstrap';
import HistologiaFiltro from '../common/histologia-filtro.container';
import '../common/histologia.styles.css';
import CancelarContainer from '../common/modais/cancelar/cancelar.container';
import NConformidadeContainer from '../common/modais/nconformidade/nconformidade.container';
import AdicionarLaminaContainer from '../common/modais/adicionar-lamina/adicionar-lamina.container';
import EtiquetaEmLoteComponent from '../common/etiqueta.lote.component';
import ButtonFloating from '../../../componentes/button/button-floating.component';
import { useIntl } from 'react-intl';
import HistologiaBlocosEdit from './blocos.edit.modal.page';

const LaminasPage = props => {
	const intl = useIntl()
	return (
		<div>
			{props.modalOpen && (
				<AdicionarLaminaContainer
					intl={intl}
					open={props.modalOpen}
					toggle={props.toggleModal}
					item={props.blocoSelecionado}
					tipoLaminaBloco={props.tipoLaminaBloco}
					tecnicos={props.tecnicos}
					medicos={props.medicos}
					paciente={props.paciente}
				></AdicionarLaminaContainer>
			)}
			{props.modalOpenCancelar && (
				<CancelarContainer
					open={props.modalOpenCancelar}
					toggle={props.toggleModalCancelar}
					item={props.itemInModal}
				></CancelarContainer>
			)}
			{props.modalOpenNaoConfor && (
				<NConformidadeContainer
					intl={intl}
					open={props.modalOpenNaoConfor}
					toggle={props.toggleModalNaoConfor}
					item={props.itemInModal}
					naoconformidades={props.naoconformidades}
					usuarioLocal={props.usuarioLocal}
				></NConformidadeContainer>
			)}
			{props.showModalImprimirEtiquetaEmLote && (
				<EtiquetaEmLoteComponent
					showModal={props.showModalImprimirEtiquetaEmLote}
					toggleModal={props.toggleModalImprimirEtiquetaEmLote}
					imprimirEtiquetas={props.imprimirEtiquetaEmLote}
					laminasParaEtiqueta={props.laminasParaEtiqueta}
				/>
			)}
			{props.modalHistologiaBlocos && (
				<HistologiaBlocosEdit
					openModalBlocos={props.openModalBlocos}
					blocoSelecionado={props.blocoSelecionado}
					commonActions={props.commonActions}
					modalHistologiaBlocos={props.modalHistologiaBlocos}
					buscar={props.buscar}
				/>
			)}

			<Container fluid className='mv-laminas-container'>
				<Row>
					<Col>
						<HistologiaFiltro
							intl={intl}
							limparFiltro={props.limparFiltro}
							carregando={props.carregando}
							tecnicos={props.tecnicos}
							tecnicoSelecionado={props.tecnicoSelecionado}
							periodoInicial={props.periodoInicial}
							periodoFinal={props.periodoFinal}
							onChangeData={props.onChangeData}
							onChangeTecnico={props.onChangeTecnico}
							onChangeNumeroExame={props.onChangeNumeroExame}
							onKeyPressNumeroExame={props.onKeyPressNumeroExame}
							numeroDoExame={props.numeroDoExame}
							onClickSearch={props.buscar}
							onClickOrdem={props.onClickOrdem}
							sortAsc={props.sortAsc}
							onClickOrganize={props.organizar}
							periodos={props.periodos}
							periodo={props.periodo}
							onChangePeriodo={props.onChangePeriodo}
							mudarIntervaloPeriodo={props.mudarIntervaloPeriodo}
							onKeyPressData={props.onKeyPressData}
							onChangeNumeroPedido={props.onChangeNumeroPedido}
							onKeyPressNumeroPedido={props.onKeyPressNumeroPedido}
							numeroDoPedido={props.numeroDoPedido}
						/>
						<Row style={{ height: props.altura }}>
							<DragDropComponente
								{...props}
								list={props.lista}
								onDragEndOverride={props.onDragEndOverride}
							/>
							<ButtonFloating
								actions={[
									{
										className: 'fas fa-pager',
										backgroundColor: '#e80303',
										color: '#ffffff',
										texto: `${intl.formatMessage({ id: "dashboards.cytology.toAddBlades" })}`,
										onClick: props.toggleModal
									},
									{
										className: 'mv-basico-codigo_barras',
										backgroundColor: '#2196f3',
										color: '#ffffff',
										texto: `${intl.formatMessage({ id: "dashboards.cytology.batchLabels" })}`,
										onClick: props.toggleModalImprimirEtiquetaEmLote
									}
								]}
							/>

						</Row>
					</Col>
				</Row>
			</Container>
		</div>
	);
}

export default LaminasPage;



// WEBPACK FOOTER //
// ./src/pages/histologia/laminas/laminas.page.js